<template>
  <v-container fluid class="fill-height py-0">
    <v-row class="fill-height">
      <v-col
        cols="12"
        sm="12"
        mb="5"
        lg="5"
        class="d-flex justify-center align-center createccountbg"
      >
      <v-row class="mx-5">
              <v-col cols="12" class="text-center">
                <h2 class="compeatfont white--text">
                  Welcome to Compeat
                </h2>
                <h1 class="compeatfont mb-3 white--text">The World of possibilities</h1>
              </v-col>
            </v-row>
      </v-col>
      <v-col
        cols="12"
        sm="12"
        mb="7"
        lg="7"
        class="text-center d-flex justify-center align-center"
      >
        <v-card width="500px" class="mx-auto" flat v-if="showLogin">
          <v-card-text>
            <generalAlert
              :alert="alert"
              :alertType="alertType"
              :message="successResponse"
            />
            <v-form ref="form" v-model="valid">
              <v-row>
                <v-col cols="12">
                  <v-img
                    src="../assets/Compeat-Logo-website.png"
                    width="350px"
                    class="mx-auto mb-5"
                  />
                  <!-- <h2 class="compeatfont mb-3">Sign up now to create your account</h2> -->
                  <h2 class="compeatfont">Login</h2>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <v-text-field
                    v-model="email"
                    label="Email Address"
                    dense
                    rounded
                    outlined
                    :rules="emailRules"
                    color="danetest"
                    @input="trimInput('email')"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-text-field
                    v-model="password"
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show1 ? 'text' : 'password'"
                    dense
                    label="Password"
                    class="input"
                    color="danetest"
                    rounded
                    outlined
                    :rules="[rules.required, rules.min]"
                    @click:append="show1 = !show1"
                    @input="trimInput('password')"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" class="text-center py-0">
                  <v-btn 
                    @click="switchForms()"
                    rounded 
                    small 
                    text 
                    class="black--text">
                    Forgot Password?
                  </v-btn>
                </v-col>
                <v-col cols="12" class="text-center">
                  <v-btn
                    small
                    class="primary mr-1"
                    rounded
                    @click="createAccount()"
                    >Create Account</v-btn
                  >
                  <v-btn
                    small
                    class="primary ml-1"
                    :loading="loading"
                    rounded
                    @click="login()"
                    >LogIn</v-btn
                  >
                </v-col>
                <v-col cols="12">
                  <v-btn 
                    @click="privacyPolicy('https://compeat.social/privacy-policy/')"
                    rounded 
                    small 
                    text 
                    color="pink"
                    class="black--text">
                    Privacy Policy
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
        <v-card v-else width="500px" class="mx-auto" flat>
          <v-card-text>
            <generalAlert
              :alert="alert"
              :alertType="alertType"
              :message="successResponse"
            />
              <v-row>
                <v-col cols="12">
                  <v-img
                    src="../assets/Compeat-Logo-website.png"
                    width="350px"
                    class="mx-auto mb-5"
                  />
                  <!-- <h2 class="compeatfont mb-3">Sign up now to create your account</h2> -->
                  <h2 class="compeatfont">Forgot Password</h2>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <v-text-field
                    v-model="email"
                    label="Email Address"
                    dense
                    rounded
                    outlined
                    :rules="emailRules"
                    color="danetest"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" class="text-center">
                  <v-btn
                    small
                    class="primary mr-1"
                    rounded
                    @click="switchForms()"
                    >Login</v-btn
                  >
                  <v-btn
                    small
                    class="primary ml-1"
                    :loading="loading"
                    rounded
                    @click="submitForgotPassword()"
                    >Submit</v-btn
                  >
                </v-col>
              </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { getAuth, signInWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";
import { getFunctions, httpsCallable } from "firebase/functions";
import { firebaseApp } from "../firebaseConfig";
import generalAlert from "@/components/alerts/generalAlert.vue";
// import generalAlert from '../components/alerts/generalAlert.vue'

export default {
  name: "Login",
  components: {
    generalAlert,
  },
  data: () => ({
    showLogin: true,
    show1: false,
    successResponse: "",
    alert: false,
    alertType: "",
    loading: false,
    loadingForgotPassword: false,
    firstName: "",
    lastName: "",
    mobile: "",
    email: "",
    password: "",
    userType: "Agency",
    valid: false,
    rules: {
      required: (value) => !!value || "Required.",
      min: (v) => v.length >= 8 || "Min 8 characters",
    },
    emailRules: [
      (v) => !!v || "E-mail is Required",
      (v) => /.+@.+\..+/.test(v) || "Email is required",
    ],
  }),
  // created(){
  //   if(this.$store.state.user != ''){
  //     this.$router.push('/')
  //   }
  // },
  methods: {
    trimInput(field) {
      this[field] = this[field].trim();
    },
    validate() {
      this.$refs.form.validate();
    },
    successAlert(message, typeOfAlert) {
      this.successResponse = message;
      this.alertType = typeOfAlert;
      this.alert = true;
      setTimeout(() => {
        this.loading = false;
        this.alert = false;
      }, 3000);
    },
    switchForms() {
      this.showLogin = !this.showLogin;
    },
    login() {
      this.loading = true;
      const auth = getAuth();
      signInWithEmailAndPassword(auth, this.email, this.password)
        .then((userCredential) => {
          // Signed in
          const user = userCredential.user;
          this.alert = true;
          this.alertType = "success";
          this.successResponse = "Sign in successfully. Welcome!";
          this.successAlert(this.successResponse, this.alertType);
          console.log("user", user);
          // ...
          setTimeout(() => {
            this.loading = false;
            this.$router.push("/");
          }, 3000);
        })
        .catch((error) => {
          this.loading = false;
          const errorMessage = error.message;
          this.alert = true;
          this.alertType = "error";
          this.successResponse =
            "Opps something went wrong " + errorMessage + "!";
          this.loading = false;
          setTimeout(() => {
            this.alert = false;
          }, 5000);
        });
    },
    createAccount(){
      this.$router.push('/create-account')
    },
    submitForgotPassword(){
        this.loadingForgotPassword = true;
        this.loading = true
        try{
          const functions = getFunctions(firebaseApp, "europe-west2");
          const forgotPassword = httpsCallable(functions, "forgotPassword");
  
          forgotPassword({
            email:this.email,
          }).then((result) => {
              console.log('result activatePayPalSub', result)
              if(result.data.response === 'No matching email address found.'){
                this.alert = true;
                this.alertType = "error";
                this.successResponse = result.data.response;
                this.loading = false;
                setTimeout(() => {
                  this.alert = false;
                }, 8000);
              }
              else {
                this.alert = true;
                this.alertType = "success";
                this.successResponse = "Password Reset Email Has been Sent";
                this.$emit("successAlert", this.successResponse, this.alertType);
                this.loadingForgotPassword = false
                this.loading = false
                this.show = false;
                this.showLogin = true
              }
          });
        }catch(error){
              console.log(error)
              this.overlay = false;
              this.alert = true;
              this.alertType = "error";
              this.successResponse = `Error Password Reset Email`;
              setTimeout(() => {
                this.alert = false;
              }, 8000);
        }
      },
      privacyPolicy(url){
        window.open(url, '_blank');
      }
  },
};
</script>
<style scoped>
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus textarea:-webkit-autofill,
textarea:-webkit-autofill:hover textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  -webkit-box-shadow: 0 0 0px 30px #ffffff inset !important;
}

.background {
  background-image: url("../assets/AppScreen.jpg");
  width: 100%;
  min-height: 100vh;
  background-size: cover;
}

.Details-block {
  border-radius: 13px;
  background: linear-gradient(#242123, #757374);
}

.font {
  font-size: 18px;
  font-family: "Segoe UI";
  font-weight: bold;
}

::placeholder {
  color: #eebf00 !important;
  opacity: 1;
}

:-ms-input-placeholder {
  color: #eebf00 !important;
}

.theme--light.v-input input,
.theme--light.v-input textarea {
  color: #eebf00 !important;
}

::-ms-input-placeholder {
  color: #eebf00 !important;
}

.custom-placeholer-color input::placeholder {
  color: #eebf00 !important;
  opacity: 1;
}

.custom-label-color .v-label {
  color: #eebf00 !important;
  opacity: 1;
}

.theme--light.v-input-field {
  color: #eebf00 !important;
}

.login {
  border-radius: 50px;
  background-color: #eebf00;
  color: white;
  height: 53px;
  width: 201px;
  margin-top: 6%;
}

.theme--light.v-input input,
.theme--light.v-input textarea {
  background-color: #eebf00 !important;
}
</style>
